import { useQueryClient } from '@tanstack/vue-query';
import useDeleteFromCartMutation from '../api/useDeleteFromCartMutation';
import builder from '../../../shared/builders/dataLayer';

export default function useDeleteFromCart() {
  const { mutate, ...state } = useDeleteFromCartMutation();
  const queryClient = useQueryClient();
  const { removeFromCartEvent, removeSerenityPackFromCartEvent, reset: resetBuilder } = builder();

  const deleteFromCart = (itemId) => {
    mutate(itemId, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['cart'], exact: true });
        queryClient.invalidateQueries({ queryKey: ['user'], exact: true });
      },
    });
  };

  const removeFromCartTag = (item, quantity = null) => {
    window.dataLayer.push(resetBuilder());
    window.dataLayer.push(removeFromCartEvent(item, quantity));
  };

  const removeSerenityPackFromCartTag = (serenityPack) => {
    window.dataLayer.push(resetBuilder());
    window.dataLayer.push(removeSerenityPackFromCartEvent(serenityPack));
  };

  return {
    isLoading: state.isPending,
    deleteFromCart,
    removeFromCartTag,
    removeSerenityPackFromCartTag,
  };
}
